module.exports = __webpack_public_path__ + "static/media/project-data.a05cc073.png";